import { useCallback, useEffect, useRef } from 'react';
import { WindowGeometry } from '../../../windows/types';
import {
  Direction,
  getWindowGeometryOnResize,
} from '../../../windows/helpers/adjustWindow';

export interface ResizersProps {
  geometry: WindowGeometry;
  onResize: (geometry: WindowGeometry, isStopped?: boolean) => void;
  disabled?: boolean;
}

export default ({ geometry, onResize }: ResizersProps) => {
  const direction = useRef<Direction>();

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (direction.current) {
        const newGeometry = getWindowGeometryOnResize(
          direction.current,
          e.pageX,
          e.pageY,
          geometry
        );

        // onResize(newGeometry);
        requestAnimationFrame(() => onResize(newGeometry));
      }
    },
    [geometry, onResize]
  );

  const handleMouseUp = useCallback(
    (e: MouseEvent) => {
      if (direction.current) {
        const newGeometry = getWindowGeometryOnResize(
          direction.current,
          e.pageX,
          e.pageY,
          geometry
        );
        onResize(newGeometry, true);
      }

      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    },
    [handleMouseMove, onResize]
  );

  const handleMouseDown = useCallback(
    (e: React.MouseEvent, dir: Direction) => {
      e.preventDefault();
      direction.current = dir;
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [handleMouseMove, handleMouseUp]
  );

  return handleMouseDown;
};
